export const TipoProceso = {
  REPORTE_CONSULTA_DOCUMENTOS: "REPORTE_CONSULTA_DOCUMENTOS",
};
